import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_INFO, MENU_STRUCTURE } from '../data';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-slate-300 pt-16 pb-8 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-3">
              <img
                src="https://assets.auxodev.dk/assets/c39928d5-b2a6-4904-83a9-11ba7b5b852e/untitled-1-03-0.jpg"
                alt="Vester-Bo Logo"
                className="h-12 w-auto object-contain bg-white rounded-lg p-1"
              />
              <span className="font-serif text-xl font-bold tracking-tight text-white">Vester-Bo</span>
            </Link>
            <p className="text-sm text-slate-400 leading-relaxed">
              Social-psykiatrisk opholdssted i Holsted med personaledækning døgnet rundt. Vi skaber trygge rammer for udvikling og trivsel.
            </p>
            <div className="pt-2">
              <img
                src="https://assets.auxodev.dk/assets/c39928d5-b2a6-4904-83a9-11ba7b5b852e/botlog.png"
                alt="Vester-Bo Bundlogo"
                className="h-10 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
              />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-serif text-lg font-semibold text-white mb-6">Hurtige links</h3>
            <ul className="space-y-3.5 text-sm">
              <li>
                <Link to="/" className="hover:text-primary transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-primary" />
                  <span>Forside</span>
                </Link>
              </li>
              {MENU_STRUCTURE.flatMap(item => item.isMega ? item.children : [item]).map((item) => (
                <li key={item.label}>
                  <Link to={item.href} className="hover:text-primary transition-colors flex items-center gap-2">
                    <i className="fa-solid fa-chevron-right text-[10px] text-primary" />
                    <span>{item.label}</span>
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/contact" className="hover:text-primary transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-primary" />
                  <span>Kontakt</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Details */}
          <div>
            <h3 className="font-serif text-lg font-semibold text-white mb-6">Kontakt os</h3>
            <ul className="space-y-4 text-sm text-slate-400">
              <li className="flex items-start gap-3">
                <i className="fa-light fa-location-dot text-primary text-base mt-0.5" />
                <span>{CONTACT_INFO.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-light fa-phone text-primary text-base" />
                <a href={`tel:${CONTACT_INFO.phone}`} className="hover:text-primary transition-colors">{CONTACT_INFO.phone}</a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-light fa-envelope text-primary text-base" />
                <a href={`mailto:${CONTACT_INFO.email}`} className="hover:text-primary transition-colors">{CONTACT_INFO.email}</a>
              </li>
            </ul>
          </div>

          {/* Tilsyn & Ledige Pladser */}
          <div>
            <h3 className="font-serif text-lg font-semibold text-white mb-6">Tilsyn & Pladser</h3>
            <div className="space-y-4">
              <div className="bg-slate-800/50 p-4 rounded-xl border border-slate-800">
                <h4 className="text-xs font-semibold uppercase tracking-wider text-primary mb-1.5">Tilsynsrapport</h4>
                <p className="text-xs text-slate-400 mb-3">Læs Socialtilsynets seneste rapport for Vester-Bo.</p>
                <a
                  href={CONTACT_INFO.tilsynsrapportUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-xs font-semibold text-white bg-primary hover:bg-primary-dark px-3.5 py-2 rounded-lg transition-colors"
                >
                  <i className="fa-regular fa-file-pdf" />
                  <span>Åben Tilsynsrapport 2024</span>
                </a>
              </div>

              <div className="bg-slate-800/50 p-4 rounded-xl border border-slate-800">
                <h4 className="text-xs font-semibold uppercase tracking-wider text-teal-400 mb-1">Ledige pladser</h4>
                <p className="text-xs text-slate-400">
                  Vi har <strong className="text-white">ledige</strong> pladser pt.
                </p>
                <Link to="/ledige-pladser" className="text-xs text-primary hover:underline font-semibold mt-1.5 inline-block">
                  Læs mere her →
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 mt-8 border-t border-slate-800 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-slate-500">
          <div>
            © {currentYear} {CONTACT_INFO.name}. Alle rettigheder forbeholdes.
          </div>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            <a href={CONTACT_INFO.privacyPolicyUrl} target="_blank" rel="noopener noreferrer" className="hover:text-slate-300 transition-colors">
              Privatlivspolitik
            </a>
            <a href={CONTACT_INFO.cookiePolicyUrl} target="_blank" rel="noopener noreferrer" className="hover:text-slate-300 transition-colors">
              Cookiepolitik
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
